import { useMutation } from "@tanstack/react-query";

import { signIn } from "../lib/auth";

export function useLogin() {
  return useMutation({
    mutationFn: async (returnTo: string) => signIn(returnTo),
  });
}
